import "@backstage/cli/asset-types";
import ReactDOM from "react-dom/client";
import App from "./App";
import "@backstage/ui/css/styles.css";

// Fix scrollbar issue - ensure body and #root are constrained to viewport
const style = document.createElement("style");
style.textContent = `
  body {
    height: 100vh;
    overflow: hidden;
  }
  #root {
    height: 100%;
  }
`;
document.head.appendChild(style);

ReactDOM.createRoot(document.getElementById("root")!).render(<App />);
